export default __webpack_public_path__ + "62bc3d783a562453414e41186bcf8392.svg";